import { render, staticRenderFns } from "./ReferansDuzenle.vue?vue&type=template&id=7b8115fc&scoped=true&"
import script from "./ReferansDuzenle.vue?vue&type=script&lang=js&"
export * from "./ReferansDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./ReferansDuzenle.vue?vue&type=style&index=0&id=7b8115fc&scoped=true&lang=css&"
import style1 from "./ReferansDuzenle.vue?vue&type=style&index=1&id=7b8115fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8115fc",
  null
  
)

export default component.exports